export default "__VITE_ASSET__7ef2f3ad__"